<script lang="ts" setup>
import SearchIcon from '~/assets/icons/search-icon/24/search-gray.svg?component'
import CloseIcon from '~/assets/icons/close.svg?component'
import NullIcon from '~/assets/icons/search-bar/null.svg?component'
import ArrowLeftIcon from '~/assets/icons/arrows/arrowWithStickLeft2.svg?component'
import ArrowRightIcon from '~/assets/icons/arrows/16/arrow-right.svg?component'
import Tabs from '~/components/ui/tabs/Tabs.vue'
import useScrollInfo from '~/composables/use-scroll-info'
import type { IScrollInfo } from '~/shared/interfaces/composables'
import {MeiliSearch} from 'meilisearch'

const props = defineProps<{
  isOpen?: boolean
}>()

const emits = defineEmits(['openMobileSearch'])
const config = useRuntimeConfig()
const client = new MeiliSearch({
  host: config.public.meilisearchHost,
  apiKey: config.public.meilisearchApiKey
})

let valueMobileSearch = ref('')
let resultSearch = ref<object>({})
let scrollInfo: IScrollInfo | null = null
const router = useRouter()
const input = ref<HTMLInputElement>()
const searchResults = ref<HTMLDivElement>()

const searchTabs = [
  {
    name: 'Артикул',
    value: 'article',
  },
  {
    name: 'Наименование',
    value: 'name',
  },
]
type searchCategory = 'article' | 'name'
let currentSearchCategory = ref<searchCategory>('article')
const multiSearchResults = ref()

// MeiliSearch
const { search, result } = useMeiliSearch('product_cards')
const params = reactive({
  hitsPerPage: 12,
  page: 1,
})

watch([valueMobileSearch, params], () => {
  multiSearch()
})

watch(
  () => props.isOpen,
  () => {
    if (props.isOpen) {
      nextTick(() => input.value?.focus())
    }
  }
)

watch(searchResults, () => {
  if (searchResults.value) {
    scrollInfo = useScrollInfo(searchResults.value)
  }
})

async function meiliSearch() {
  resultSearch.value = await search(valueMobileSearch.value, {
    filter: ['availability = "true"'],
    showRankingScore: true,
    ...params,
  })
  return resultSearch
}

async function multiSearch(searchStr: string) {
  try {
    const res = await client.multiSearch({
      queries: [
        {
          indexUid: 'product_cards',
          q: valueMobileSearch.value,
          attributesToSearchOn: ['article'],
          hitsPerPage: 3,
          filter: ['availability = "true"']
        },
        {
          indexUid: 'product_cards',
          q: valueMobileSearch.value,
          attributesToSearchOn: ['title'],
          hitsPerPage: 3,
          filter: ['availability = "true"']
        },
      ]
    })
    multiSearchResults.value = res.results
    console.log(multiSearchResults.value)
  } catch (e) {
    console.log('This is wrong action...', e)
  }
}

function setSearchCategory(category: searchCategory) {
  if (currentSearchCategory.value != category) {
    currentSearchCategory.value = category
    if (currentSearchCategory.value == 'article') {
      resultSearch.value = {}
    } else {
      meiliSearch()
    }
  }
  input.value?.focus()
}

function methodSearch() {
  if (valueMobileSearch.value.length == 0) return false
  const regValue = /([\%\/\\\&\?\!\+\!\@\#\$\^\*])/g
  valueMobileSearch.value = valueMobileSearch.value.replace(regValue, '')
  if (
    currentSearchCategory.value == 'article' &&
    valueMobileSearch.value.length > 1
  )
    router.push({ path: `/search/${valueMobileSearch.value}` })
  if (currentSearchCategory.value == 'name')
    router.push({ path: `/search/query/${valueMobileSearch.value}` })
  closeSearch()
}

function closeSearch() {
  emits('openMobileSearch', false)
}

function clearSearchValue() {
  valueMobileSearch.value = ''
  input.value?.focus()
}
</script>
<template>
  <div class="search-mobile">
    <div class="search-mobile__title">
      <div class="search-mobile__close" @click="closeSearch">
        <ArrowLeftIcon />
      </div>
      <p>Поиск</p>
    </div>
    <div class="search-mobile__tabs">
      <Tabs
        :tabs-list="searchTabs"
        :naver-color="'orange'"
        @tab-setter="setSearchCategory"
      />
    </div>
    <div class="search-mobile__input">
      <div class="search-mobile__icon">
        <SearchIcon />
      </div>
      <input
        v-model="valueMobileSearch"
        @keyup.enter="methodSearch"
        ref="input"
        type="text"
        inputmode="search"
      />
      <div
        class="search-mobile__icon"
        v-show="valueMobileSearch.length"
        @click="clearSearchValue"
      >
        <CloseIcon />
      </div>
    </div>
    <div
      class="search-mobile__results"
      ref="searchResults"
    >
      <div class="search-mobile__list" v-if="multiSearchResults">
        <NuxtLink
          v-for="itemSearch in multiSearchResults[0].hits"
          :to="`/search/${itemSearch.article}/${itemSearch.brand}`"
          class="search-mobile__article-link"
          @click="closeSearch"
        >
          <div class="search-mobile__result">
            <div class="search-mobile__text">
              <p class="search-mobile__article">
                {{ itemSearch.article }}
              </p>
            </div>
          </div>
        </NuxtLink>
        <div class="search-mobile__results-separator"></div>
        <NuxtLink
          v-for="itemSearch in multiSearchResults[1].hits"
          :to="`/search/query/${itemSearch.title}`"
          @click="closeSearch"
        >
          <div class="search-mobile__result">
            <div class="search-mobile__img">
              <NullIcon v-if="!itemSearch.photo" />
              <nuxt-img
                v-else
                :src="itemSearch.photo"
                loading="lazy"
                width="44"
                height="44"
              />
            </div>
            <div class="search-mobile__text">
              <p class="search-mobile__description">
                {{ itemSearch.title }}
              </p>
              <p class="search-mobile__name">
                {{ itemSearch.brand }} <span></span> {{ itemSearch.article }}
              </p>
            </div>
          </div>
        </NuxtLink>
      </div>
    </div>
    <div
      class="search-mobile__more"
    >
      <NuxtLink
        class="search-mobile__all"
        @click.prevent="methodSearch"
        v-if="valueMobileSearch"
      >
        Посмотреть все
        <ArrowRightIcon />
      </NuxtLink>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.search-mobile {
  width: 100%;
  position: absolute;
  z-index: 3000;
  background: $bg_page;
  height: 100vh;
  top: 0;
  left: 0;
  align-items: center;
  //padding: 20px;

  &__close {
    position: absolute;
    left: 0;
  }
  &__title {
    @include font(18px, 24px, 600);
    position: relative;
    display: flex;
    justify-content: center;
    margin: 24px 20px 20px 20px;
  }
  &__tabs {
    padding: 0 20px;
    //width: 320px;
    height: 48px;
  }
  &__icon {
    display: flex;
    align-items: center;
  }
  &__input {
    margin: 12px 20px;
    gap: 8px;
    display: flex;
    align-items: center;
    border: 2px solid $control-border_black;
    border-radius: 8px;
    height: 48px;
    padding: 0 16px;
    input {
      @include font(16px, 20px, 400);
      height: 20px;
      width: 100%;
    }
  }
  &__results {
    margin: 4px;
    height: calc(var(--vh, 1vh) * 100 - 276px);
    overflow-y: scroll;

    &-separator {
      width: 100%;
      height: 1px;
      background-color: $bg_border;
      margin: 4px 0;
    }
  }
  &__list {
    padding: 0 12px 0 16px;
  }
  &__article-link {
    .search-mobile__result {
      padding: 4px 0;
    }
    &:not(:first-child) {
      margin-top: 4px;
    }
  }
  &__result {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 8px 0;
  }
  &__description {
    @include font(14px, 20px, 400);
  }
  &__img {
    width: 44px;
    height: 44px;
    img {
      width: 44px;
    }
  }
  &__name {
    @include font(14px, 20px, 400);
    color: $content_tretiary;
    display: flex;
    align-items: center;
    gap: 4px;
    span {
      background: $content_icons;
      width: 4px;
      height: 4px;
      border-radius: 50%;
    }
  }
  &__more {
    padding-top: 20px;
    p {
      display: flex;
      align-items: center;
      justify-content: center;
      @include font(14px, 20px, 400);
      color: $content_tretiary;
    }
  }
  &__all {
    @include font(14px, 20px, 500);
    gap: 8px;
    margin: 12px auto 0;
    width: calc(100% - 40px);
    border-radius: 8px;
    background: $control-bg_neutral;
    color: $content_primary;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
